import { render, staticRenderFns } from "./ownerComplaints.vue?vue&type=template&id=20186b56&scoped=true"
import script from "./ownerComplaints.vue?vue&type=script&lang=js"
export * from "./ownerComplaints.vue?vue&type=script&lang=js"
import style0 from "./ownerComplaints.vue?vue&type=style&index=0&id=20186b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20186b56",
  null
  
)

export default component.exports